import { render, staticRenderFns } from "./accountAuditDetail.vue?vue&type=template&id=47f22435&scoped=true&"
import script from "./accountAuditDetail.vue?vue&type=script&lang=js&"
export * from "./accountAuditDetail.vue?vue&type=script&lang=js&"
import style0 from "./accountAuditDetail.vue?vue&type=style&index=0&id=47f22435&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f22435",
  null
  
)

export default component.exports